import { FC } from 'react';

export const Tableview: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM4 12V14H13V12H4ZM4 10V6L20 6V10H4ZM15 12V14H20V12H15ZM20 16H15V18H20V16ZM13 18V16H4V18H13Z"
			fill="currentColor"
		/>
	</svg>
);
